import { useEffect, useRef, useState } from "react";

import { timeSince } from "../../../../../utils/utils";

interface ITimeSinceProps {
	createdAt: Date;
	runEveryMs?: number;
}

const TimeSince: React.FC<ITimeSinceProps> = ({ createdAt, runEveryMs = 60000 }) => {

	const initialize = timeSince(createdAt, 'short');
	const [time, setTime] = useState(initialize);

	const timeout = useRef<NodeJS.Timeout | null>(null);

	useEffect(() => {
		const runTimer = () => {
			timeout.current = setTimeout(() => {
				if (timeout.current) {
					clearTimeout(timeout.current);
				}
				setTime(timeSince(createdAt, 'short'));
				runTimer();
			}, runEveryMs);
		};
		runTimer();

		return () => {
			if (timeout.current) {
				clearTimeout(timeout.current);
			}
		};

	}, [createdAt, runEveryMs]);

	return <>{time}</>;
};

export default TimeSince;
